import request from 'services/request';
const AGREEMENTS_API = '/Agreements/Api/v1/';
const AGREEMENTS_INFO = `${AGREEMENTS_API}SellOut/Info/`;

export async function getInfo(indicatorName, params, cancelToken) {
  return request(`${AGREEMENTS_INFO}${indicatorName}`, {
    method: 'GET',
    params,
    cancelToken,
  });
}
